// source: PublicAggreBookTickerV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.PublicAggreBookTickerV3Api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicAggreBookTickerV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PublicAggreBookTickerV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicAggreBookTickerV3Api.displayName = 'proto.PublicAggreBookTickerV3Api';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicAggreBookTickerV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicAggreBookTickerV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicAggreBookTickerV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicAggreBookTickerV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
bidprice: jspb.Message.getFieldWithDefault(msg, 1, ""),
bidquantity: jspb.Message.getFieldWithDefault(msg, 2, ""),
askprice: jspb.Message.getFieldWithDefault(msg, 3, ""),
askquantity: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicAggreBookTickerV3Api}
 */
proto.PublicAggreBookTickerV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicAggreBookTickerV3Api;
  return proto.PublicAggreBookTickerV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicAggreBookTickerV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicAggreBookTickerV3Api}
 */
proto.PublicAggreBookTickerV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBidprice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setBidquantity(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAskprice(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAskquantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicAggreBookTickerV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicAggreBookTickerV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicAggreBookTickerV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicAggreBookTickerV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBidprice();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBidquantity();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAskprice();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAskquantity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string bidPrice = 1;
 * @return {string}
 */
proto.PublicAggreBookTickerV3Api.prototype.getBidprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicAggreBookTickerV3Api} returns this
 */
proto.PublicAggreBookTickerV3Api.prototype.setBidprice = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bidQuantity = 2;
 * @return {string}
 */
proto.PublicAggreBookTickerV3Api.prototype.getBidquantity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicAggreBookTickerV3Api} returns this
 */
proto.PublicAggreBookTickerV3Api.prototype.setBidquantity = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string askPrice = 3;
 * @return {string}
 */
proto.PublicAggreBookTickerV3Api.prototype.getAskprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicAggreBookTickerV3Api} returns this
 */
proto.PublicAggreBookTickerV3Api.prototype.setAskprice = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string askQuantity = 4;
 * @return {string}
 */
proto.PublicAggreBookTickerV3Api.prototype.getAskquantity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicAggreBookTickerV3Api} returns this
 */
proto.PublicAggreBookTickerV3Api.prototype.setAskquantity = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto);
